export default "__VITE_ASSET__TN$F$2AM__"